import classnames, { ArgumentArray } from 'classnames';

export const basicPrefix = 'mt-design-rc';

export const getPrefix = (subPrefix: string) => `${basicPrefix}-${subPrefix}`;

const getClsWithPrefix = (subPrefix: string) => {
    const prefix = getPrefix(subPrefix);
    const cls = (...args: ArgumentArray): string => {
        if (args.length === 0) return prefix;
        return classnames(
            args.map((arg) => {
                if (typeof arg === 'string') {
                    return arg === '' ? prefix : `${prefix}__${arg}`;
                } else if (Array.isArray(arg)) {
                    return arg.map((a) => cls(a)).join(' ');
                }
                return Object.entries(arg as any)
                    .filter(([_, v]) => v)
                    .map(([arg]) => (arg === '' ? prefix : `${prefix}__${arg}`));
            }),
        );
    };
    return cls;
};

export default getClsWithPrefix;
